// Mirrors the Android team's EvidenceScore enum: which of the 5 states the
// progress bar/copy/button are in depends only on whether the incident
// details are filled in and how much evidence has been stored so far.
// Container background is violet while incident details or evidence are
// still missing, and switches to green once there's enough to share -
// matches iOS's colorBgSurfaceEvidence/colorBgSurfaceEvidence200 tokens.
const BACKGROUND_VIOLET = "#E8E7FC";
const BACKGROUND_GREEN = "#E7F9FC";

// progress is the bar's actual fill %, which iOS deliberately pulls below
// the state's design % (25/50/50/70/95) so the bar never looks nearly
// complete while details or evidence are still missing - only the last
// state has fill == design. Don't "fix" these to match the design %.
export const EVIDENCE_SCORES = {
  INCIDENT_MISSING_NO_EVIDENCE: {
    progress: 0.15,
    textKey: "casesPage.caseCard.progressScoreBar.state1",
    background: BACKGROUND_VIOLET
  },
  INCIDENT_DONE_NO_EVIDENCE: {
    progress: 0.4,
    textKey: "casesPage.caseCard.progressScoreBar.state2",
    background: BACKGROUND_VIOLET
  },
  INCIDENT_MISSING_HAS_EVIDENCE: {
    progress: 0.4,
    textKey: "casesPage.caseCard.progressScoreBar.state5",
    background: BACKGROUND_VIOLET
  },
  SOME_EVIDENCE: {
    progress: 0.65,
    textKey: "casesPage.caseCard.progressScoreBar.state3",
    background: BACKGROUND_GREEN
  },
  LOTS_OF_EVIDENCE: {
    progress: 0.95,
    textKey: "casesPage.caseCard.progressScoreBar.state4",
    background: BACKGROUND_GREEN
  }
};

export function getEvidenceScore(incidentDetailsCompleted, evidenceStored) {
  if (!incidentDetailsCompleted && evidenceStored === 0) {
    return EVIDENCE_SCORES.INCIDENT_MISSING_NO_EVIDENCE;
  }
  if (incidentDetailsCompleted && evidenceStored === 0) {
    return EVIDENCE_SCORES.INCIDENT_DONE_NO_EVIDENCE;
  }
  if (incidentDetailsCompleted && evidenceStored >= 1 && evidenceStored <= 4) {
    return EVIDENCE_SCORES.SOME_EVIDENCE;
  }
  if (incidentDetailsCompleted && evidenceStored >= 5) {
    return EVIDENCE_SCORES.LOTS_OF_EVIDENCE;
  }
  return EVIDENCE_SCORES.INCIDENT_MISSING_HAS_EVIDENCE;
}
